import {HeroContainer} from "../components/HomePage/HeroContainer";
import {ServicesContainer} from "../components/HomePage/ServicesContainer";
import {AboutMeContainer} from "../components/HomePage/AboutMe";
import {OverviewContainer} from "../components/HomePage/Overview";
import {SocialContainer} from "../components/HomePage/Social";


export const Homepage = () => {
    return (
        <div>
            <HeroContainer/>
            <ServicesContainer/>
            <AboutMeContainer/>
            <OverviewContainer/>
            <SocialContainer/>
        </div>
    )
}